import { Box, Button, Chip, Divider, makeStyles, SvgIcon, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditBarIcon from 'components/Icons/EditBarIcon';
import { fonts } from 'theme';
import { ClientContract } from 'types';

const useStyles = makeStyles({
  materialTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: fonts.secondary,
    fontWeight: 600,
    fontSize: '14px',
    marginLeft: '1em',
    alignItems: 'center',
  },
  collapsableDivider: {
    marginBottom: '9px',
  },
  materialListContainer: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: '35px',
  },
  materialList: {
    display: 'flex',
    width: '49%',
    flexWrap: 'wrap',

    '& > *': {
      marginTop: '2px',
    },
  },
  activeInactive: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: fonts.secondary,
    fontWeight: 600,

    '& > div': {
      display: 'flex',
      width: '50%',
      justifyContent: 'center',
    },
  },
  active: {
    color: '#8BC296',
  },
  inactive: {
    color: '#E37280',
  },
  updateButton: {
    color: '#2F3741',
  },
});

interface CollapsableContentShowProps {
  clientContracts: ClientContract[] | null;
  clientId: string;
  buyerId: string;
  canUpdate: boolean;
  onClickUpdateButton: () => void;
}

export const CollapsableContentShow: React.FC<CollapsableContentShowProps> = ({
  clientContracts,
  clientId,
  buyerId,
  canUpdate,
  onClickUpdateButton,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'clients' });
  const hasContracts = null !== clientContracts && 0 < clientContracts.length;

  const activeContracts = clientContracts
    ? clientContracts.filter((contract: ClientContract) => contract.isActive)
    : [];

  const inActiveContracts = clientContracts
    ? clientContracts.filter((contract: ClientContract) => !contract.isActive)
    : [];

  return (
    <Box>
      <Typography className={classes.materialTitle}>
        <div>{t('buyersList.material')}</div>

        <div>
          {canUpdate && (
            <Button className={classes.updateButton} onClick={onClickUpdateButton}>
              <SvgIcon component={EditBarIcon} fontSize="large" />
            </Button>
          )}
        </div>
      </Typography>
      <Divider className={classes.collapsableDivider} />
      {hasContracts && (
        <>
          <Box className={classes.materialListContainer}>
            <Box className={classes.materialList}>
              {activeContracts.map(contract => (
                <Chip
                  key={`client_${clientId}_buyer_${buyerId}_${contract.material.shortName}`}
                  label={contract.material.shortName}
                />
              ))}
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box className={classes.materialList}>
              {inActiveContracts.map(contract => (
                <Chip
                  key={`client_${clientId}_buyer_${buyerId}_${contract.material.shortName}`}
                  label={contract.material.shortName}
                />
              ))}
            </Box>
          </Box>
          <Box className={classes.activeInactive}>
            <Box className={classes.active}>{t('buyersList.active')}</Box>
            <Box className={classes.inactive}>{t('buyersList.inactive')}</Box>
          </Box>
        </>
      )}
    </Box>
  );
};
